/*!
 * 
 *
 * 	This file is auto generated by webpack.
 * 	Do not edit this file directly.
 *
 *
 */
/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 989:
/***/ (function() {

function getHeaderOffset() {
  var headerHeight = getComputedStyle(document.body).getPropertyValue('--header-height');
  return parseFloat(headerHeight) || 0;
}

function scrollToTarget(targetElement) {
  var smooth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var headerOffset = getHeaderOffset();
  var elementPosition = targetElement.getBoundingClientRect().top;
  var offsetPosition = elementPosition + window.scrollY - headerOffset;
  window.scrollTo({
    top: offsetPosition,
    behavior: smooth ? 'smooth' : 'auto'
  });
}

function waitForHeaderHeight(callback) {
  var maxAttempts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
  var attempts = 0;
  var lastHeight = 0;
  var stableCount = 0;
  var requiredStableChecks = 2;

  function check() {
    var currentHeight = getHeaderOffset();

    if (currentHeight > 0 && currentHeight === lastHeight) {
      stableCount++;

      if (stableCount >= requiredStableChecks) {
        callback();
        return;
      }
    } else {
      stableCount = 0;
      lastHeight = currentHeight;
    }

    attempts++;

    if (attempts >= maxAttempts) {
      callback();
      return;
    }

    requestAnimationFrame(check);
  }

  requestAnimationFrame(check);
}

function initAnchorScroll() {
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) {
      return;
    }

    var link = event.target.closest('a[href*="#"]');

    if (!link) {
      return;
    }

    var href = link.getAttribute('href');

    if (!href) {
      return;
    }

    var hash;

    try {
      var url = new URL(href, window.location.href);

      if (url.pathname !== window.location.pathname) {
        return;
      }

      hash = url.hash;
    } catch (e) {
      if (href.startsWith('#')) {
        hash = href;
      } else {
        return;
      }
    }

    if (!hash || hash === '#') {
      return;
    }

    var targetId = hash.substring(1);
    var targetElement = document.getElementById(targetId);

    if (!targetElement) {
      return;
    }

    event.preventDefault();
    scrollToTarget(targetElement);

    if (history.pushState) {
      history.pushState(null, '', hash);
    } else {
      window.location.hash = hash;
    }
  });

  if (window.location.hash) {
    window.addEventListener('load', function () {
      waitForHeaderHeight(function () {
        var targetId = window.location.hash.substring(1);
        var targetElement = document.getElementById(targetId);

        if (targetElement) {
          scrollToTarget(targetElement, false);
        }
      });
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAnchorScroll);
} else {
  initAnchorScroll();
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
/* harmony import */ var _partials_anchor_scroll_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(989);
/* harmony import */ var _partials_anchor_scroll_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_partials_anchor_scroll_js__WEBPACK_IMPORTED_MODULE_0__);



}();
/******/ })()
;